import { render } from "./Organizers.vue?vue&type=template&id=1235ae44"
import script from "./Organizers.vue?vue&type=script&lang=js"
export * from "./Organizers.vue?vue&type=script&lang=js"

import "./Organizers.vue?vue&type=style&index=0&id=1235ae44&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__